<template>
  <v-content class="content_body" id="apolice">
    <p id="forced-scroll"></p>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12 class="mb-3" v-if="product.coberturas">
          <v-layout
            row
            wrap
            v-for="(product, index) in product.coberturas.filter(
              (item) => item.tipo != 'adicional'
            )"
            :key="index"
          >
            <v-flex md4 sm12>
              <v-text-field
                class="jns-input"
                :label="getModalidadeNameByType(product.tipo)"
                v-model="product.nome_comercial"
                :title="product.nome_comercial"
                disabled
                placeholder=" "
              ></v-text-field>
            </v-flex>

            <!-- valor recursal / Segurado Pessoa Física -->
            <template v-if="recursal">
              <v-flex md2 sm12>
                <v-text-field
                  class="jns-input"
                  label="Valor do Recurso *"
                  id="emissao_apolice_input_valor_recurso"
                  v-model="product.valor_recurso"
                  v-money="moneyConfig"
                  placeholder=" "
                  @input="calculaImportancia(product)"
                ></v-text-field>
              </v-flex>

              <v-flex md2 sm12>
                <v-text-field
                  class="jns-input"
                  label="Importância Segurada *"
                  id="importancia_segurada_pessoa_fisica"
                  :value="
                    product.importancia_segurada_formatada == null
                      ? 'R$0,00'
                      : product.importancia_segurada_formatada
                  "
                  placeholder=" "
                  :disabled="recursal"
                  autofocus
                ></v-text-field>

                <v-icon
                  v-if="recursal"
                  class="icon_recursal"
                  @mouseover="showTooltipRecursal = true"
                  @mouseleave="showTooltipRecursal = false"
                  >help</v-icon
                >
                <div class="msg_recursal" v-if="showTooltipRecursal">
                  Conforme Art. 3° do Ato Conjunto n°1, para o seguro garantia
                  para Depósito Recursal, o valor da Importância Segurada deverá
                  ser igual ao montante da condenação, acrescido de 30%.
                </div>
              </v-flex>
              <!--./ valor recursal / Segurado Pessoa Física -->
            </template>

            <!-- valor normal / Segurado Pessoa Jurídica -->
            <v-flex md2 sm12 v-else>
              <v-text-field
                class="jns-input"
                label="Importância Segurada *"
                id="emissao_apolice_input_importancia_segurada"
                v-model="product.importancia_segurada"
                v-money="moneyConfig"
                placeholder=" "
              ></v-text-field>
            </v-flex>
            <!-- ./valor normal / Segurado Pessoa Jurídica -->

            <v-flex md2 sm12>
              <v-menu
                lazy
                v-model="inicioVigenciaMenu[index]"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                :close-on-content-click="false"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  class="jns-input jns-datepicker"
                  label="Início Vigência *"
                  v-model="product.inicio_vigenciaFormatted"
                  append-icon="event"
                  id="emissao_apolice_input_inicio_vigencia"
                  placeholder=" "
                  disabled
                ></v-text-field>
                <v-date-picker
                  v-model="product.inicio_vigencia"
                  @input="updateVigencia(product, 'inicio')"
                  @change="inicioVigenciaMenu[index] = false"
                  no-title
                  scrollable
                  locale="pt-BR"
                  actions
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 sm12 v-if="recursal">
              <v-select
                v-model="prazoAno"
                label="Prazo em anos"
                :items="anos"
                :item-value="'index'"
                :item-text="'description'"
                class="jns-input"
                id="emissao_apolice_input_prazo_anos"
                @change="updatePrazo(product)"
                @select="updatePrazo(product)"
                outlined
              ></v-select>
            </v-flex>

            <template v-else>
              <v-flex md2 sm12>
                <v-text-field
                  class="jns-input"
                  label="Prazo Dias"
                  id="emissao_apolice_input_prazo_dias"
                  @input="updatePrazo(product)"
                  v-model="product.prazo"
                  v-mask="['#####']"
                  placeholder=" "
                ></v-text-field>
              </v-flex>

              <v-flex md2 sm12>
                <v-menu
                  lazy
                  v-model="fimVigenciaMenu[index]"
                  transition="scale-transition"
                  full-width
                  :nudge-right="40"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    class="jns-input jns-datepicker"
                    label="Fim Vigência *"
                    v-model="product.fim_vigenciaFormatted"
                    append-icon="event"
                    placeholder=" "
                    id="emissao_apolice_input_fim_vigencia"
                    disabled
                  ></v-text-field>

                  <v-date-picker
                    v-model="product.fim_vigencia"
                    locale="pt-BR"
                    @input="updateVigencia(product, 'fim')"
                    @change="fimVigenciaMenu[index] = false"
                    :min="getFimVigenciaMinimumDate(product)"
                    no-title
                    scrollable
                    actions
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </template>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <p class="titulo">Limites e taxas do tomador</p>
          <limites-taxas
            :carregando="buscandoLimite"
            :taker="taker"
            :step="step"
            :tipo_pessoa="this.tipo_pessoa"
            :id_grupo="this.product.id_grupo"
            :erroBuscaLimite="erroBuscaLimite"
            :msgErroBuscaLimite="msgErroBuscaLimite"
          ></limites-taxas>
        </v-flex>
        <!-- ./Tabela de limites e taxas do tomador -->

        <!-- Tags -->
        <v-flex xs12>
          <v-divider class="mb-3"></v-divider>
          <v-layout row wrap v-if="product">
            <v-flex xs12>
              <p class="titulo">Objeto</p>
            </v-flex>

            <v-flex md3 sm12 v-for="(tag, index) in TAGs" :key="index">
              <v-text-field
                class="jns-input"
                :label="tag.original"
                v-model="tag.value"
                placeholder=" "
                id="emissao_apolice_input_objeto_tag"
                @keyup="changeTagPlaceholderContent($event, tag)"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 v-if="product && product.objeto">
              <v-card
                class="white-background"
                v-html="product.objeto.replace(/(?:\r\n|\r|\n)/g, '<br />')"
              ></v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-content>
</template>

<script lang="js">
import { VMoney } from "v-money";
import { formatDate } from "@/libs/utils";

export default {
  name: "ApolicePasso4",
  props: [
    "taker",
    "step",
    "product",
    "inicioVigenciaMenu",
    "fimVigenciaMenu",
    "buscandoLimite",
    "tipo_pessoa",
    "TAGs",
    "msgErroBuscaLimite",
    "erroBuscaLimite",
  ],
  directives: { money: VMoney },
  data: function () {
    return {
      moneyConfig: {},
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      recursal: false,
      showTooltipRecursal: false,
      isInputValorActive: false,
      prazoAno: 0,
      anos: [
        { index: 0, description: "Prazo" },
        { index: 3, description: "3 anos" },
        { index: 4, description: "4 anos" },
        { index: 5, description: "5 anos" },
      ],
    };
  },
  methods: {
    calculaImportancia(product) {
      let valor = this.retiraFormatacao(product.valor_recurso);
      if (valor != "0") {
        try {
          var trintaPorcento = parseFloat(valor) * 0.3;
          valor = parseFloat(valor) + parseFloat(trintaPorcento);
        } catch (error) {
          valor = 0;
        }
      }
      product.importancia_segurada_formatada = valor.toLocaleString(
        "pt-BR",
        this.$settings.moneyFormatOptions
      );
      product.importancia_segurada = valor;
    },

    getModalidadeNameByType(type) {
      let modalidade =
        type == "basica"
          ? "Modalidade Principal"
          : type == "corretiva"
          ? "Modalidade Complementar"
          : false;
      return modalidade;
    },

    // type pode ser inicio ou fim,
    // pra casar com inicio_vigencia ou fim_vigencia
    updateVigencia(product, type) {
      product[type + "_vigenciaFormatted"] = product[type + "_vigencia"]
        .split("-")
        .reverse()
        .join("/");

      if (type == "inicio") {
        this.calculateFimVigencia(product);
      }
      if (type == "fim") {
        product.prazo = this.calculateDifferenceBetweenDays(
          product.inicio_vigencia,
          product.fim_vigencia
        );
      }

      this.$forceUpdate();
    },

    calculateDifferenceBetweenDays(inicio, fim) {
      if (inicio != undefined && fim != undefined) {
        let dateInicio = new Date(inicio);
        let dateFim = new Date(fim);
        let timeDiff = Math.abs(dateFim.getTime() - dateInicio.getTime());
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays;
      } else {
        return "";
      }
    },

    async updatePrazo(product) {
      await this.$nextTick();
      this.calculateFimVigencia(product);
    },

    calculateFimVigencia(product) {
      if (!this.recursal) {
        if (!product.inicio_vigencia || !product.prazo) return;
        let fimVigencia = this.addDays(product.inicio_vigencia, +product.prazo);
        product.fim_vigencia = fimVigencia.toISOString().split("T")[0];
        product.fim_vigenciaFormatted = formatDate(
          product.fim_vigencia
        );
        this.$forceUpdate();
      } else {
        this.calculaFimVigenciaRecursal(product);
      }
    },

    calculaFimVigenciaRecursal(product) {
      if (this.prazoAno > 0) {
        let fimVigencia = this.addYears(product.inicio_vigencia, this.prazoAno);
        product.fim_vigencia = fimVigencia.toISOString().split("T")[0];
        product.fim_vigenciaFormatted = formatDate(
          product.fim_vigencia
        );
        this.$forceUpdate();
      }
    },

    addDays(date, days) {
      var someDate = new Date(date);
      someDate.setTime(someDate.getTime() + days * 24 * 60 * 60 * 1000);
      return someDate;
    },

    addYears(date, years) {
      let year = new Date().getFullYear() + years;
      let someDate = new Date(date);
      someDate.setFullYear(year);
      return someDate;
    },

    // TODO: Entender porque tem duas funções com o mesmo nome e que cada uma faz
    getFimVigenciaMinimumDate(product) {
      return new Date(product.inicio_vigencia) > new Date()
        ? product.inicio_vigencia
        : new Date().toISOString().slice(0, 10);
    },

    changeTagPlaceholderContent(event, tag) {
      this.$emit("changeTagPlaceholderContent", event, tag);
    },

    getFimVigenciaMinimumDate(event) {
      this.$emit("getFimVigenciaMinimumDate", event);
    },

    pessoaRecursal() {
      if (this.tipo_pessoa == "FISICA") {
        this.recursal = true;
      } else this.recursal = false;
    },

    retiraFormatacao(valor) {
      if (valor) {
        let valorSemFormatacao = valor.toString();
        while (valorSemFormatacao.toString().lastIndexOf(".") > -1) {
          valorSemFormatacao = valorSemFormatacao.toString().replace(".", "");
        }

        valorSemFormatacao = valorSemFormatacao
          .toString()
          .replace(".", "")
          .replace(",", ".")
          .replace(/[^0-9\.]/g, "")
          .replace("R$", "");

        return valorSemFormatacao;
      } else return "0";
    },

    scrollToStartAndEnd(){
      let elmnt = document.getElementById('forced-scroll')
      elmnt.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    },
  },
  mounted() {
    this.scrollToStartAndEnd()
    window.scrollTo(0, 0);
    this.moneyConfig = this.$settings.moneyConfig;
    this.pessoaRecursal();
    this.$forceUpdate();
  },
  watch: {
    buscandoLimite: function (newValue) {
      if (newValue) window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
#jns {
  .content_body {
    padding: 20px 40px 77px 40px;
    background-color: white;
  }

  .icon_recursal {
    float: right;
    top: -53px;
    position: relative;
    cursor: help;
    right: 10px;
  }

  .msg_recursal {
    width: 53%;
    background-color: white;
    color: black;
    //position: relative;
    border-radius: 4px;
    z-index: 99999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    position: absolute;
    left: 23%;
    top: 8.5%;
    font-size: 13px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Propostas/Passos/Apolice.vue